/** @format */

import React, { Component } from "react";
import Main from "../components/Main";
import Hire from "../components/Hire";
import Projects from "../components/Projects";
import Recommendations from "../components/Recommendations";
import BlogLink from "../components/BlogLink";

class Home extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		return (
			<>
				<Main />
				<Hire />
				<Projects />
				<Recommendations />
				<BlogLink />
			</>
		);
	}
}

export default Home;
